<div class="content">
  @if (userPerformanceDefaults()) {
    <app-performance-defaults
      [performanceDefaults]="userPerformanceDefaults().performanceDefaults"
      (selectionChanged)="performanceDefaultUpdated($event)">
    </app-performance-defaults>
  }
</div>
@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  </div>
}
